/** Org location entity from `/bff/locations` (`locationsApi` in `locationSlice.ts`). */
export type Location = {
  id: string
  organizationId: string
  name: string
  status: boolean
  isDefault: boolean

  address1: string | null
  address2: string | null
  suburb: string | null
  state: string | null
  postcode: string | null
  phoneNumber: string | null
  email: string | null

  createdAt: string
  updatedAt: string

  prescribers?: PrescriberProfile[]
}

export type PrescriberProfile = {
  id: string
  prescriberId: string
  providerNumber: string
  title: string
  givenNames: string
  familyName: string
}

export type CreateLocationRequest = {
  name: string
  address1?: string | null
  address2?: string | null
  suburb?: string | null
  state?: string | null
  postcode?: string | null
  phoneNumber?: string | null
  email?: string | null
}

export type UpdateLocationRequest = Partial<CreateLocationRequest> & {
  status?: boolean
}

export interface JoinLocationRequest {
  providerNumber?: string
  phoneNumber?: string
  email?: string
}

export type UpdateLocationProfileRequest = Partial<JoinLocationRequest>

export type LocationProfileContactFormValues = {
  providerNumber: string
  phoneNumber: string
  email: string
}

export type PrescriberLocationProfile = {
  id: string
  locationId: string
  address1: string
  address2?: string | null
  suburb: string
  state: string
  postcode: string
  name: string
  isDefault: boolean
  providerNumber?: string | null
  phoneNumber: string
  email: string
  joined: boolean
  joinedAt: string
}

export const formatLocationAddress = (location: Location | PrescriberLocationProfile): string => {
  const parts = [
    location.address1,
    location.address2,
    location.suburb,
    location.state,
    location.postcode,
  ].filter(Boolean)
  return parts.join(', ')
}

export const formatPrescriberName = (prescriber: PrescriberProfile): string =>
  [prescriber.title, prescriber.givenNames, prescriber.familyName].filter(Boolean).join(' ')
